import React, { useMemo } from 'react';
import { usePopulatedMeeting__INTERNAL_USE_ONLY } from './data';
import { MeetingUtilsContext } from './context';
import { MeetingContainer } from '@kalyzee/kast-web-sdk';
import { LoadingView } from '../../components/utils/LoadingView';

export type MeetingUtilsProviderProps = {
  container: MeetingContainer;
  children: React.ReactNode;
};

export const MeetingUtilsProvider: React.FC<MeetingUtilsProviderProps> = ({
  container,
  children,
}) => {
  const containerAPI = container.getAPI();
  const populated = usePopulatedMeeting__INTERNAL_USE_ONLY(containerAPI);

  const utils = useMemo(() => (populated ? {
    populated,
    containerAPI,
  } : undefined), [containerAPI, populated]);

  (window as any).meetingUtils = utils;

  // Store data not ready yey,
  // could not build utils
  if (!utils) {
    return <LoadingView message="Chargement en cours ..." fullscreen />;
  }

  return (
    <MeetingUtilsContext.Provider value={utils}>
      {children}
    </MeetingUtilsContext.Provider>
  );
};
